import { Link } from "react-router-dom";
import { usePageTitle } from "../components/usePageTitle";

export default function NotFound() {
  usePageTitle("Page not found");
  return (
    <section className="page-head">
      <div className="wrap narrow center">
        <h1 className="display">this page took the wrong train.</h1>
        <p className="lede">The old site is gone, and this address didn’t make the trip.</p>
        <Link className="btn" to="/">
          Back to the platform
        </Link>
      </div>
    </section>
  );
}
